<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>

<div class="subBlockContainer" id="openquotes">
    <div class="subBlockContent" *ngIf="!narrow">
      <child-header [title]="title" (closeEvent)="close()"></child-header>
        <div class="inner-subBlock-wrapper">
<!--            <div class="page-title-wrapper">-->
<!--                <div class="title blade-title-font">-->
<!--                    {{title}}-->
<!--                </div>-->
<!--                <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>-->
<!--            </div>-->

            <div class="filter-wrapper">
                <div class="searchInputGroup">
                    <div class="searchIcon">
                        <img src="../images/new_ui/filter.png">
                    </div>
                    <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
                        onblur="this.placeholder='Filter'" [(ngModel)]="filterInput" (ngModelChange)="onChange()">
                </div>
            </div>

            <ng-container *ngIf="hasEmptyFilterResult">
                <div class="noResult-wrapper">
                    <div class="top-divider"></div>
                    <div><img src="../images/new_ui/no-found.png"></div>
                    <div>No results found</div>
                    <div>Sorry, that filter combination has no results.<br>Please try different criteria.</div>
                    <button (click)="filterReset()" class="button button-red button-large">Try again</button>
                    <div class="noResult-feedback">Send Feedback</div>
                </div>
            </ng-container>

            <ng-container *ngIf="loadContent && !hasEmptyFilterResult">
                <div *ngIf="!hasEmptyFilterResult">
                    <div class="top-divider"></div>
                    <div class="shared-outer-wrapper">
                        <table matSort (matSortChange)="sortData($event)" class="white">
                            <thead>
                                <tr class="row">
                                    <th class="col quoteId" mat-sort-header="quoteId">QUOTE ID</th>
                                    <!-- <th class="col" mat-sort-header="quoteVersionNo" style="min-width:8%">RESELLER REF</th> -->
                                    <!-- <th class="col" mat-sort-header="quoteName" style="min-width:29%">OPPOTUNITY DESCRIPTION</th> -->
                                    <th class="col" mat-sort-header="brand">Brand</th>
                                    <th class="col" mat-sort-header="endUser">End User</th>
                                    <th class="col" mat-sort-header="validTo">EXPIRY DATE</th>
                                    <!-- <th class="col totalEx" mat-sort-header="quoteTotal">TOTAL EX</th> -->
                                    <th class="col quoteButton"></th>
                                    <th class="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container
                                    *ngFor="let quote of sortedData | TableFilterMultiple:['quoteId', 'quoteVersionNo', 'quoteName', 'validTo', 'quoteTotal'] : filterInput">
                                    <tr class="row">
                                        <td class="col margin-l-x4">{{quote?.quoteId}}</td>
                                        <!-- <td class="col" style="min-width:8%">{{quote?.comment}}</td> -->
                                        <td class="col">{{quote?.out_brand}}</td>
                                        <td class="col">{{quote?.out_end_user_name}}</td>
                                        <!-- <td class="col" style="min-width:29%">{{quote?.reference}}</td> -->
                                        <td class="col">{{quote?.validTo.split("-").join("/")}}</td>
                                        <!-- <td class="col align-right quoteTotal">
                                            {{quote?.quoteTotal| currency:'AUD':'symbol-narrow':'.2-2'}}
                                        </td> -->
                                        <td class="col quoteButton">
                                            <!-- <div id="catDownloadButton" (click)="download(quote)"></div> -->
                                        </td>
                                        <td class="col align-center">
                                            <!-- <button class="button button-red button-mid" [routerLink]="['quotesItemsDetials/'+ quote?.quoteId]">View</button> -->
                                            <!-- <a [routerLink]="['quotesItemsDetials/'+ quote?.quoteId]" class="red-link">View Quote</a> -->
<!--                                            <a [routerLink]="['pricelistDetails/', quote.quoteId,quote.out_published_version]"-->
                                          <!--                                                class="red-link">Details</a>-->
                                          <span class="return-link" (click)="goQuoteDetail(quote)"
                                                [class.active]="selectedOrder === quote?.quoteId+quote?.out_published_version"
                                          >Details</span>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                </div>

            </ng-container>
        </div>
        <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)">
        </loading-screen>
    </div>


  <div class="blockContainer narrow-sidebar narrow-sidebar-overflow" id="levelTwo"
       *ngIf="narrow">

    <div class="combination-loader">

      <div class="child-sidebar sidebar-loader">
        <child-header [title]="title" (closeEvent)="close()"></child-header>

        <div class="child-body renewal-list-mini">
          <div class="searchInputGroup">
            <div class="searchIcon search-carts">
              <img src="../images/site-icons/search-red.svg">
            </div>
            <input class="searchInput searchInputGroup-small" type="text"
                   placeholder="Search Invoice Number" onfocus="this.placeholder=''"
                   onblur="this.placeholder='Filter Orders'" [(ngModel)]="filterInput" (ngModelChange)="onChange()">
          </div>
          <ng-container
            *ngFor="let quote of sortedData | TableFilterMultiple:['quoteId', 'quoteVersionNo', 'quoteName', 'validTo', 'quoteTotal'] : filterInput">
            <!--            [class.active]="selectedSerial == item.out_serial"-->
            <div class="menu-wrapper menu-wrapper-position"
                 (click)="goQuoteDetail(quote)" [class.active]="selectedOrder === quote?.quoteId+quote?.out_published_version">
              <!--                 (click)="goReturnsDetail(order)"-->
              <!--                 [class.active]="selectedOrder == order.orderNo+'-'+order.orderSuffix"-->

              <div class="total-div">
                <div class="narrow-title truncate">
                  {{quote?.quoteId}}
                </div>
                <span class="narrow-text">
                                     Date:{{quote?.validTo.split("-").join("/")}}
                  | Total: {{quote?.quoteTotal| currency:'AUD':'symbol-narrow':'.2-2'}}
                                  </span><br>

                <!-- <span class="narrow-text">
                {{item.out_opportunity_id}}</span> -->
              </div>
            </div>

          </ng-container>
          <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)">
          </loading-screen>

        </div>
      </div>

      <div class="child-loader">
        <router-outlet></router-outlet>
      </div>

    </div>

  </div>


</div>

